import { linkFactory } from '@mews/routing';

const wrapComponentWithLink = ({ LinkElement, WrappedComponent }: $TSFixMe) => {
    const LinkComponent = linkFactory({ LinkElement });

    return ({ route, routeParams, ...other }: $TSFixMe) => {
        if (!route) {
            throw new Error('Provide route argument');
        }
        return (
            // @ts-expect-error $TSFixMeError: Type '{ children: Element; route: any; params: any; }' is not assignable to type 'IntrinsicAttributes & Omit<LinkProps<u...
            <LinkComponent route={route} params={routeParams}>
                <WrappedComponent {...other} />
            </LinkComponent>
        );
    };
};

export default wrapComponentWithLink;
